import FieldWrapper from '~/utils/formik/FieldWrapper'
import FastFieldWrapper from '~/utils/formik/FastFieldWrapper'

import Input from './Input'
import Select from './Select'
import Checkbox from './Checkbox'
import DayPicker from '../Formik/DayPicker'
import Radio from './Radio'
import NumberInput from './NumberInput'
import AsyncSelect from './AsyncSelect'
import ToggleSwitch from './ToggleSwitch'
import TimeSelect from './TimeSelect'
import AmountWUnitInput from './AmountWUnitInput'
import SelectCenter from './SelectCenter'
import TextEditor from './TextEditor'

export const Field = {
  Input: FieldWrapper(Input),
  Select: FieldWrapper(Select),
  SelectCenter: FieldWrapper(SelectCenter),
  Checkbox: FieldWrapper(Checkbox),
  DayPicker: FieldWrapper(DayPicker),
  Radio: FieldWrapper(Radio),
  NumberInput: FieldWrapper(NumberInput),
  AsyncSelect: FieldWrapper(AsyncSelect),
  ToggleSwitch: FieldWrapper(ToggleSwitch),
  TimeSelect: FieldWrapper(TimeSelect),
  AmountWUnitInput: FieldWrapper(AmountWUnitInput),
  TextEditor: FieldWrapper(TextEditor),
}

export const FastField = {
  Input: FastFieldWrapper(Input),
  Select: FastFieldWrapper(Select),
  SelectCenter: FastFieldWrapper(SelectCenter),
  Checkbox: FastFieldWrapper(Checkbox),
  DayPicker: FastFieldWrapper(DayPicker),
  Radio: FastFieldWrapper(Radio),
  NumberInput: FastFieldWrapper(NumberInput),
  AsyncSelect: FastFieldWrapper(AsyncSelect),
  ToggleSwitch: FastFieldWrapper(ToggleSwitch),
  TimeSelect: FastFieldWrapper(TimeSelect),
  AmountWUnitInput: FastFieldWrapper(AmountWUnitInput),
  TextEditor: FastFieldWrapper(TextEditor),
}

export default {
  Field,
  FastField,
}
